module.exports = __webpack_public_path__ + "img/how_shop_2.753e9364.png";